import { initLocalStore } from '@thoughtspot/local-store';
import { create } from '@thoughtspot/logger';
const logger = create('mfe-local-store-init');
let initialized = false;
export function initializeMFELocalStore(webStorageService) {
    if (initialized) {
        logger.log('MFE local-store already initialized, skipping');
        return;
    }
    try {
        if (webStorageService?.localStore) {
            initLocalStore(webStorageService.localStore);
            initialized = true;
            logger.log('MFE local-store initialized successfully');
        }
        else {
            logger.warn('webStorageService.localStore not available');
        }
    }
    catch (error) {
        logger.error('Failed to initialize MFE local-store:', error);
    }
}
export function isMFELocalStoreInitialized() {
    return initialized;
}
export function resetMFELocalStoreInitialization() {
    initialized = false;
    logger.log('MFE local-store initialization state reset');
}
//# sourceMappingURL=mfe-local-store-init.js.map